import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuthStore } from '../store/authStore';
import api from '../services/api';
import toast from 'react-hot-toast';

const NAV = [
  { label: 'Dashboard',       to: '/employer/dashboard',       icon: '🏠' },
  { label: 'My Requirements', to: '/employer/requirements',    icon: '📋' },
  { label: 'Search Workers',  to: '/employer/workers/search',  icon: '🔍' },
  { label: 'Saved Workers',   to: '/employer/workers/saved',   icon: '⭐' },
  { label: 'Profile',         to: '/employer/profile',         icon: '🏢' },
];

export default function EmployerLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const logout   = useAuthStore((s) => s.logout);
  const [mobileOpen, setMobileOpen] = useState(false);

  async function handleLogout() {
    try { await api.post('/auth/logout'); } catch {}
    logout();
    navigate('/login');
    toast.success('Logged out');
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-india text-white sticky top-0 z-40 shadow">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button
              onClick={() => setMobileOpen(true)}
              className="md:hidden p-1 text-white text-xl leading-none"
              aria-label="Open menu"
            >
              ☰
            </button>
            <Link to="/employer/dashboard" className="font-bold text-lg">naukarihaat.com</Link>
          </div>
          <button onClick={handleLogout} className="text-sm hover:underline">Logout</button>
        </div>
      </header>

      <div className="flex flex-1">
        {/* Desktop Sidebar */}
        <aside className="hidden md:flex flex-col w-56 bg-white border-r border-gray-200 py-6 px-4 gap-1 fixed top-14 bottom-0">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname.startsWith(item.to)
                  ? 'bg-green-50 text-green-700'
                  : 'text-gray-600 hover:bg-gray-50'
              }`}
            >
              {item.icon} {item.label}
            </Link>
          ))}
          <div className="mt-auto">
            <button
              onClick={handleLogout}
              className="flex items-center gap-3 px-3 py-2.5 text-sm text-red-600 hover:bg-red-50 rounded-lg w-full"
            >
              🚪 Logout
            </button>
          </div>
        </aside>

        {/* Mobile Drawer */}
        {mobileOpen && (
          <div
            className="md:hidden fixed inset-0 z-50 bg-black/50"
            onClick={() => setMobileOpen(false)}
          >
            <div
              className="bg-white w-72 h-full flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-5 border-b border-gray-200 flex items-center justify-between">
                <span className="font-bold text-lg text-gray-900">Menu</span>
                <button
                  onClick={() => setMobileOpen(false)}
                  className="text-gray-500 hover:text-gray-900 text-xl"
                  aria-label="Close menu"
                >
                  ✕
                </button>
              </div>
              <nav className="flex-1 py-4 px-3 space-y-0.5 overflow-y-auto">
                {NAV.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    onClick={() => setMobileOpen(false)}
                    className={`flex items-center gap-3 px-3 py-3 rounded-lg text-base font-medium ${
                      location.pathname.startsWith(item.to)
                        ? 'bg-green-50 text-green-700'
                        : 'text-gray-700 hover:bg-gray-50'
                    }`}
                  >
                    {item.icon} {item.label}
                  </Link>
                ))}
              </nav>
              <div className="p-4 border-t border-gray-200">
                <button
                  onClick={handleLogout}
                  className="flex items-center gap-3 px-3 py-3 text-red-600 rounded-lg w-full hover:bg-red-50"
                >
                  🚪 Logout
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Main Content */}
        <main className="flex-1 md:ml-56 p-4 md:p-6 max-w-6xl w-full pb-20 md:pb-6">
          {children}
        </main>
      </div>

      {/* Mobile Bottom Nav — first 4 items + More */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex z-40">
        {NAV.slice(0, 4).map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`flex-1 flex flex-col items-center py-2 text-xs ${
              location.pathname.startsWith(item.to) ? 'text-green-700' : 'text-gray-500'
            }`}
          >
            <span className="text-lg">{item.icon}</span>
            {item.label.split(' ')[0]}
          </Link>
        ))}
        <button
          onClick={() => setMobileOpen(true)}
          className="flex-1 flex flex-col items-center py-2 text-xs text-gray-500"
        >
          <span className="text-lg">☰</span>
          More
        </button>
      </nav>
    </div>
  );
}
